var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHouse = function SvgHouse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#191F2E",
    d: "M9.796 1.688a1.125 1.125 0 0 0-1.591 0L.727 9.165a.563.563 0 0 0 .796.795l.727-.727v5.954c0 .932.756 1.688 1.688 1.688h10.125c.931 0 1.687-.756 1.687-1.687V9.233l.727.727a.562.562 0 1 0 .796-.795l-2.648-2.648V2.813a.56.56 0 0 0-.562-.563h-1.126a.56.56 0 0 0-.562.563v1.454zm4.829 6.42v7.08c0 .31-.252.562-.562.562H3.938a.56.56 0 0 1-.563-.562v-7.08L9 2.483z"
  })));
};
export default SvgHouse;